import {AfterViewInit, Component, OnInit} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {InviteAFriendComponent} from "../../modals/invite-a-friend/invite-a-friend.component";
import {EventsManager} from "../../../events/events.manager";
import {environment} from "../../../../environments/environment";
import { Router, RouterLink } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { NgClass, NgIf } from '@angular/common';
import { Info } from 'src/app/models/info.model';

@Component({
  selector: 'app-subheader',
  templateUrl: './subheader.component.html',
  styleUrls: ['./subheader.component.scss'],
  standalone: true,
  imports: [NgClass, RouterLink, NgIf]
})
export class SubheaderComponent implements OnInit,AfterViewInit {
  office: any = {};
  environment:any = environment;
  info: Info = {telephoneNumber:'', address: '',weekDayHours:'',weekendHours:''};
  hideLearnMore: boolean = false;
  supportLink: string = '/support';
  findADentistLink: string = '/find-a-dentist';
  currentRoute: string = '';
  constructor(private em: EventsManager, public modalService: NgbModal, private router: Router, private googleAnalyticsService: GoogleAnalyticsService) {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  ngOnInit(): void {
    this.office = this.em.getOfficeInfo();
    this.em.officeUpdate.subscribe(
      (result) => {
        this.office = result;
      }
    )

    this.em.contactInfoUpdated.subscribe(
      (info:any) => {
        this.info = this.em.contactInfo;
      }
    )


  }

  ngAfterViewInit(): void {
    this.em.hideHeader.subscribe(
      (hideHeader:boolean) => {
        this.hideLearnMore = hideHeader;
        if(this.hideLearnMore){
          this.supportLink = '/adha/support';
          this.findADentistLink = '/adha/find-a-dentist';
        }
      }
    )
  }

  inviteAFriend(){
    const modalRef: NgbModalRef = this.modalService.open(InviteAFriendComponent);
    modalRef.result.then(
      () => {
        this.closeModal();
      },
      error => {
        console.log('error: ',error);
      }
    )
  }

  closeModal() {
    this.modalService.dismissAll();
  }
  onCall() {
    this.googleAnalyticsService.sendKeyEvent('click_to_call', {
      timestamp: new Date().toISOString()
    })
  }
  memberLogin() {
    this.googleAnalyticsService.sendKeyEvent('Click_member_login', {
      timestamp: new Date().toISOString()
    })
  }

  findDentist() {
    this.googleAnalyticsService.sendKeyEvent('find_dentist', {
      timestamp: new Date().toISOString()
    })
  }
}
